import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'user'
const plural = 'users'
const single = 'user'

const userManagement = new ApiCore({
	index: true,
	findOne: false,
	create: true,
	update: false,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

userManagement.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, params)
		.then(handleResponse)
		.catch(handleError);
}

userManagement.checkUser = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/if-exists/${params}`)
		.then(handleResponse)
		.catch(handleError);
}

userManagement.delete = (id) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

userManagement.deletes = (params) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}`, { data: params })
		.then(handleResponse)
		.catch(handleError);
}

userManagement.edit = (userId, params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/user/${userId}`, params)
		.then(handleResponse)
		.catch(handleError)
}

userManagement.edits = (params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}`, params)
		.then(handleResponse)
		.catch(handleError)
}

userManagement.hasAtLeastOneMakerCheckerRole = (orgId, params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/maker-checker/org/${orgId}/at-least-one-makercheckerrole`, params)
		.then(handleResponse)
		.catch(handleError)
}

export default userManagement
